module.exports = __webpack_public_path__ + "static/hero2-2649d50ed8be290e4b751955bcf5a2ab.webp";